var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Utils, PropertyConverters, Defaults } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
import { ChangePolicy } from './input';
//namespace Pacem.Components.Scaffolding {
const ITEM_TXT_CORE = `change-policy="${ChangePolicy.Blur}" readonly="{{ :host.readonly }}"`;
function isEmpty(nvp) {
    return Utils.isNullOrEmpty(nvp && nvp.name);
}
function pullEmpty() {
    return { name: '', value: '' };
}
let PacemNameValueListElement = class PacemNameValueListElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        this.inputFields = [];
        this._bag = [];
    }
    toggleReadonlyView(readonly) {
        // let the bindings do their job...
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            let val = this._bagToValue(this._bag);
            if (!this.compareValuePropertyValues(val, this.value)) {
                resolve(this.value = val);
            }
            else {
                reject();
            }
        });
    }
    acceptValue(val) {
        this._bag = this._valueToBag(val);
    }
    getViewValue(value) {
        return ''; // unneeded
    }
    compareValuePropertyValues(old, val) {
        return Utils.Json.stringify(old) === Utils.Json.stringify(val);
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Json.convert(attr);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'dictionary' && !first) {
            this.value = this._bagToValue();
        }
    }
    _bagToValue(bag = this._bag) {
        if (!this.dictionary) {
            // not a dictionary
            // return an array
            let b = [];
            for (let item of bag || []) {
                if (isEmpty(item)) {
                    continue;
                }
                if (b.find(i => i.name === item.name && i.value === item.value)) {
                    continue;
                }
                b.push(item);
            }
            return b;
        }
        // dictionary
        // return an object
        let v = {};
        for (let kvp of bag || []) {
            if (kvp.name in v) {
                // skip existing names...
                continue;
            }
            v[kvp.name] = kvp.value;
        }
        return v;
    }
    _valueToBag(val = this.value) {
        const bag = [];
        if (!Utils.isNullOrEmpty(val) && typeof val === 'object') {
            if (this.dictionary && !Utils.isArray(val)) {
                for (let prop in val) {
                    bag.push({ name: prop, value: val[prop] });
                }
            }
            else if (!this.dictionary && Utils.isArray(val)) {
                Array.prototype.splice.apply(bag, [0, 0].concat(val.map(i => Utils.clone(i))));
            }
        }
        return !Utils.isNullOrEmpty(bag) ? bag : [pullEmpty()];
    }
    _deleteAt(evt) {
        this._bag.splice(evt.detail, 1);
        this.changeHandler(evt);
    }
    _addItem(evt) {
        const bag = this._bag, lastItem = this._bag[this._bag.length - 1];
        if (Utils.isEmpty(bag) || !isEmpty(lastItem)) {
            bag.push(pullEmpty());
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemNameValueListElement.prototype, "dictionary", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemNameValueListElement.prototype, "_bag", void 0);
PacemNameValueListElement = __decorate([
    CustomElement({
        tagName: P + '-namevalue-list', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-repeater datasource="{{ :host._bag }}" on-itemdelete=":host._deleteAt($event)">
    <template>
        <div class="${PCSS}-fieldset ${PCSS}-margin margin-bottom-1">
            <div class="fieldset-auto">
                <div class="${PCSS}-fieldgroup">
                    <${P}-input-text ${ITEM_TXT_CORE} value="{{ ^item.name, twoway }}" on-change=":host.changeHandler($event)"></${P}-input-text>
                    <div class="fieldgroup-prepend"></div>
                </div>
                <div class="${PCSS}-fieldgroup">
                    <${P}-input-text ${ITEM_TXT_CORE} value="{{ ^item.value, twoway }}" on-change=":host.changeHandler($event)"></${P}-input-text>
                    <div class="fieldgroup-append">
                        <${P}-button class="${PCSS}-cell cols-2 flat delete" hide="{{ :host.readonly }}" command-name="delete" command-argument="{{ ^index }}"></${P}-button>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <${P}-button class="flat add" hide="{{ :host.readonly }}" on-click=":host._addItem($event)"></${P}-button>
</${P}-repeater>`
    })
], PacemNameValueListElement);
export { PacemNameValueListElement };
